export const clarityBackgrondColor = "#f0fffb";
export const maxPageWidth = 1200;
export const maxWidthCardContent = 400;
export const MIDDLEWARE_ENDPOINT = "https://58nq5poqlf.execute-api.us-east-1.amazonaws.com/midd-services";
//export const MIDDLEWARE_ENDPOINT = "https://localhost:3002";

export const valueDiabetesForm = "69eb03b0-813a-4dd2-ab15-750d998324b9";
export const valueObesidadForm = "32d1b5d0-0d4c-4eae-a5c5-8d05b4b7e6b3";
export const valueHipertensionForm = "d176073e-dda6-4193-91aa-5ade65cd26fa";
export const valueHipotoroidismoForm = "96bfd10c-290e-44fa-bdee-ea1112ba24e7";

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
